import apiClient from './api';
import type {
  Segment,
  CreateSegmentPayload,
  UpdateSegmentPayload,
  DeleteSegmentPayload,
  ApiResponse,
} from '../types/api.types';

export const segmentsService = {
  // Get all segments for a project and episode
  async getSegments(projectId: number, episodeId: number): Promise<Segment[]> {
    const response = await apiClient.get<Segment[]>(
      `/retrieve/segment/${projectId}/${episodeId}`
    );
    return response.data;
  },

  // Create a new segment
  async createSegment(payload: CreateSegmentPayload): Promise<ApiResponse> {
    const response = await apiClient.post<ApiResponse>('/save/segment', payload);
    return response.data;
  },

  // Update an existing segment
  async updateSegment(payload: UpdateSegmentPayload): Promise<ApiResponse> {
    const response = await apiClient.put<ApiResponse>('/update/segment', payload);
    return response.data;
  },

  // Delete a segment
  async deleteSegment(payload: DeleteSegmentPayload): Promise<ApiResponse> {
    const response = await apiClient.delete<ApiResponse>('/delete/segment', {
      data: payload,
    });
    return response.data;
  },
};
